import {
  useState, useEffect,
  forwardRef, useImperativeHandle, createRef,
} from 'react';
import { Item as ItemFilter } from './item';
import Emitter from '@/helpers/emitter';

const FiltersContent = forwardRef(({
  filters, onScreen, onFilter, keyFilter,
}, ref) => {
  const initItemRefs = (inputList) => {
    const refList = [];
    inputList.forEach(() => {
      refList.push(createRef());
    });
    return [...refList];
  };

  const [currentData, setCurrentData] = useState({
    filters,
    filtersRefs: initItemRefs(filters),
  });

  const getOutput = () => currentData.filtersRefs?.reduce((acc, iref) => {
    if (iref?.current?.getValue()) {
      acc.push(iref?.current?.getOutput());
    }
    return acc;
  }, []);

  const getRefs = () => currentData.filtersRefs;

  useImperativeHandle(ref, () => ({
    getOutput,
    getRefs,
  }), [currentData]);

  useEffect(() => {
    if (filters) {
      setCurrentData({
        filters,
        filtersRefs: [...initItemRefs(filters)],
      });
    }
  }, [filters]);

  function onValid() {
    if (onFilter) return null;
    // console.log('search/results/filters - on screen call emmiter');
    Emitter.emit(`${keyFilter}runSearch`);
    return null;
  }
  return (
    <>
      {(currentData.filters || []).map((item, index) => (
        <div key={`searchfilterdiv${item.id}`} className={`flex-auto ${item.classes}`}>
          <ItemFilter
            {...{
              item, onScreen, onFilter, onValid,
            }}
            ref={currentData.filtersRefs[index]}
          />
        </div>
      ))}
    </>
  );
});

export default FiltersContent;
